import { connect } from 'react-redux';
import { open as openModal, close as closeModal } from 'core/modal/redux/actions';
import JobPanelComponent from './job-panel-component';

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps, { openModal, closeModal })(JobPanelComponent);
